<div class="section-with-background d-flex flex-column justify-content-center psic-px-7 psic-py-6 psic-gap-6"
  [ngClass]="{ 'collapsed-card': !displayContent && field && field.type != 'radio'}">

  @if (field && (field.caption || field.description)) {
    <div
      class="d-flex flex-row align-items-center justify-content-between psic-gap-6">
      <div class="d-flex flex-row align-items-center psic-gap-4">
        <!-- Card Icon if icon path is present -->
        @if (field.icon_path) {
          <img src="assets/images/{{field.icon_path}}.svg" alt="card-icon" />
        }
        <div class="d-flex flex-column justify-content-center">
          <!-- Card Heading if caption is present -->
          <div class="d-flex flex-row psic-gap-1">
            @if (field.caption) {
              <h6 [innerHTML]="field.caption">{{ field.caption }}</h6>
            }
            @if (field.helpIcon) {
              <img [psicTooltip]="field.helpText" psicTooltipPlacement="right"
                src="../../../../assets/images/info-icon.svg" alt="option.value" />
            }
          </div>
          <!-- Card description if present -->
          @if (field.description) {
            <span class="caption" [innerHTML]="field.description">{{ field.description }}</span>
          }
        </div>
      </div>
      @if (field.additionalContext?.accordian) {
        @if (!displayContent) {
          <mat-icon [svgIcon]="'chevron-down-big'" (click)="toggleContent()"></mat-icon>
        }
        @if (displayContent) {
          <mat-icon [svgIcon]="'chevron-up-big'" (click)="toggleContent()"></mat-icon>
        }
      }
    </div>
  }

  @if (displayContent) {
    <div class="d-flex flex-column">
      @for (terms of field.options.optionsList; track terms) {
        @for (item of terms.options.optionsList; track item) {
          @if (item.name !== 'displayNote' && item.name !== 'autopay') {
            <div class="d-flex flex-row psic-gap-1 justify-content-between align-items-center item-container">
              @switch (item.type) {
                @case ('status-tag') {
                  <lib-tag [tagText]="item.value" [tagTheme]="getTagTheme(item.value)" [tagType]="'lineFill'"></lib-tag>
                }
                @case ('para-alt-bold') {
                  <p class="alt-bold">{{item.caption}}</p>
                  <p class="alt-bold item-value">{{item.value}}</p>
                }
                @default {
                  <p class="alt-bold">{{item.caption}}</p>
                  <p class="p-alt item-value">{{item.value}}</p>
                }
              }
            </div>
          }
          @if (item.name === 'displayNote' && item.value && item.value !== '' && item.value !== '-') {
            <div class="psic-mb-6 psic-mt-4">
              <lib-alert
                class="mt-4 mb-5 mb-md-0"
                [alertText]="item.value"
                [alertTheme]="item.type"
                [alertType]="'small'"
              ></lib-alert>
              <!-- <p class="note">{{item.value}}</p> -->
            </div>
          }
        }
        <div class="dg_mg-20-background" style="height: 1px; mix-blend-mode: normal"></div>
      }
    </div>
  }

  @if ( field && field.name == 'paymentAmount' && form()) {
    <form [formGroup]="form()!">
      <div class="d-flex flex-row justify-content-between">
        <div class="d-flex flex-column">
          @for (field of selectedAmtToPayFields; track field) {
            <lib-input-radio
              [radioLeft]="true"
              [formControlName]="field.id"
              [field]="field"
            ></lib-input-radio>
          }
        </div>
        <div class="d-flex flex-column">
          <div class="other-payment-due">
            @for (field of selectedAmtToPayFields; track field) {
              @if (field.name !='OtherDueField') {
                <div>
                  <p class="caption-bold">{{field.options.optionsList[0].value}}</p>
                </div>
              }
            }
          </div>
          <lib-input-text class="other-payment-option"
            [field]="field.getOption('OtherAmountField')!"
            [formControlName]="field.getOption('OtherAmountField')?.name || ''"
          ></lib-input-text>
        </div>
      </div>
    </form>
  }
</div>

